import { useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { getView } from '../selectors'

export const useZoom = (mapId) => {
  const view = useSelector(getView(mapId))

  useEffect(() => {
    view && view.ui.remove("zoom")
  }, [view])

  const zoomIn = useCallback(() => {
    if (view && view.zoom < 20) {
      view.zoom++
    }
  }, [view])

  
  const zoomOut = useCallback(() => {
    if (view && view.zoom > 0) {
      view.zoom--
    }
  }, [view])

  return [view && view.zoom, { zoomIn, zoomOut }]
}